import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges,
    ViewEncapsulation,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subject, take, takeUntil } from 'rxjs';
import { MailTypeIds, MailTypes } from 'src/app/core/constants/mail-box-const';
import { AuthenticationService } from 'src/app/core/services/auth/authentication.service';
import { LoaderService } from 'src/app/core/services/loader/loader.service';
import { LocalStorageService } from 'src/app/core/services/localStorage/localStorage.service';
import { MailBoxService } from 'src/app/core/services/mail-box/mail-box.service';
import { PopUpService } from 'src/app/core/services/pop-up/pop-up.service';
import { ToasterService } from 'src/app/core/services/toaster/toaster.service';
import { UniversityCommunicationService } from 'src/app/core/services/university-communication/university-communication.service';
import { ShareMailComponent } from 'src/app/views/mail-box/shared/share-mail/share-mail.component';
import { AssignMailComponent } from 'src/app/views/university-communications/shared/assign-mail/assign-mail.component';

@Component({
    selector: 'app-email-activity-mail-box',
    templateUrl: './email-activity.component.html',
    styleUrls: ['./email-activity.component.scss'],
})
export class EmailActivityComponentMailbox
    implements OnInit, OnChanges, OnDestroy {
    @Input() type: string;
    @Input() selected_mails: string;
    @Input() menu_type: any;
    @Input() user_details: any;
    @Input() email_list: any = [];
    @Input() showAssignButton: boolean = true;
    @Input() page_type: string;
    @Input() reAssignButton: boolean = false;
    @Input() showDoneButton: boolean = false;
    @Input() filter: any = null;
    @Output() trigger_reload_data: EventEmitter<any> = new EventEmitter();
    @Output() triggerReAssignClose: EventEmitter<any> = new EventEmitter();
    mail_type_ids = MailTypeIds;
    mail_types = MailTypes;
    // user_details: any;
    private _unsubscribeAll: Subject<any> = new Subject();
    show_read: boolean;
    show_unread: boolean;
    show_archive: boolean;
    show_important: boolean;
    show_junk: boolean;
    show_shared: boolean;
    showNotImportant: boolean;
    show_move_to: boolean;
    show_inbox: boolean;
    show_delete: boolean;
    mailAllotmentFolders: any = [];
    isReassign: boolean = false;
    isMMRTeam: boolean = false;

    constructor(
        private loaderService: LoaderService,
        private _universitycommunicationService: UniversityCommunicationService,
        private _popUpService: PopUpService,
        private _toasterService: ToasterService,
        public _dialog: MatDialog,
        public _mailBoxService: MailBoxService,
        public _lc: LocalStorageService,
    ) { }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['menu_type']?.currentValue) {
            this.menu_type = changes['menu_type']?.currentValue;
            this.activityButtonVisibility();
        }
        if (changes['filter']?.currentValue) {
            this.openAssignPopup(changes['filter']?.currentValue)
        }
        if (changes['reAssignButton']?.currentValue !== undefined) {
            this.isReassign = changes['reAssignButton']?.currentValue;
            if (changes['reAssignButton']?.currentValue) {
                this.openAssignPopup();
            }
        }
    }

    ngOnInit(): void {
        this.activityButtonVisibility();
        this.isMMRTeam = this._lc.isMMR();
    }

    public activityConfirmation(type1: any, type2?: any, showConformation: boolean = true): void {
        if (!this.selected_mails?.length) {
            this._universitycommunicationService.openWarningPopup('');
            return;
        }

        let find_details: any = {};
        if (type2 === 'folder') {
            let find_folder = this.user_details?.mailAllotmentFolders.find(
                (element) => element.id === type1
            );
            find_details = {
                id: Number(find_folder.id),
                type: 'folder',
                name: find_folder?.name,
                msg: `You want to move selected ${this.selected_mails?.length > 1 ? 'mails' : 'mail'
                    } to ${find_folder?.name}?`,
            };
        } else {
            if (typeof type1 === 'number') {
                let find_type = this.mail_types.find(
                    (element) => element.id === type1
                );
                if (find_type) {
                    find_details = {
                        id: Number(find_type.id),
                        type: '',
                        name: find_type?.type,
                        msg: `You want to ${find_type?.type?.toLowerCase()} selected ${this.selected_mails?.length > 1 ? 'mails' : 'mail'
                            }?`,
                    };
                }
            } else {
                if (type1 === 'read') {
                    find_details = {
                        id: this.menu_type.id,
                        name: type1,
                        type: 'read',
                        msg: `You want to mark read selected ${this.selected_mails?.length > 1 ? 'mails' : 'mail'
                            }?`,
                    };
                }
                if (type1 === 'unread') {
                    find_details = {
                        id: this.menu_type.id,
                        name: type1,
                        type: 'unread',
                        msg: `You want to mark unread selected ${this.selected_mails?.length > 1 ? 'mails' : 'mail'
                            }?`,
                    };
                }
            }
        }

        this.bulkUpdate(find_details, showConformation);

        // this._popUpService.showConfirmationPopup(
        //     'Are you sure?',
        //     find_details?.msg,
        //     'Yes',
        //     (isConfirmed: boolean) => {
        //         if (isConfirmed) {
        //             this.bulkUpdate(find_details);
        //         }
        //     },
        //     false,
        //     'No'
        // );
    }

    share() {
        const dialogRef = this._dialog.open(ShareMailComponent, {
            width: '800px',
            maxWidth: '95vw',
            enterAnimationDuration: '300ms',
            exitAnimationDuration: '100ms',
            data: {
                selected_mails: this.selected_mails,
            },
            panelClass: 'access-user-list'
        });
        dialogRef.afterClosed().subscribe((result) => {
            if (result?.value) {
                // this.trigger_reload.emit(true);
                let find_details = {
                    id: this.menu_type.id,
                    name: 'Share',
                    type: 'share',
                    share_id: result,
                    msg: `You want to share selected ${this.selected_mails?.length > 1 ? 'mails' : 'mail'
                        }?`,
                };
                this.bulkUpdate(find_details);
            }
        });
    }

    bulkUpdate(type?: any, showConformation: boolean = true) {
        let payload = '';
        const userDetails = JSON.parse(this._lc.getKey('user_details'));

        if (type?.type === 'read' || type?.type === 'unread') {
            payload = `Id=${this.selected_mails}&type=${type.id}&userId=${userDetails?.id}&isRead=${type?.type === 'read' ? true : false}`;
        } else if (type?.type === 'share') {
            payload = `Id=${this.selected_mails}&type=${type.id}&userId=${userDetails?.id}&sharedUserId=${type?.share_id}`;
        } else {
            payload = `Id=${this.selected_mails}&type=${type.id}&userId=${userDetails?.id}`;
        }

        let selectedFullMailBoxNames = this.email_list?.data
            .filter(item => this.selected_mails.includes(item.id))
            .map(item => item.fullMailBoxName) || [];
        selectedFullMailBoxNames = [...new Set(selectedFullMailBoxNames)]?.join(',');

        payload += `&userName=${userDetails?.name}`;

        if (selectedFullMailBoxNames) {
            payload += `&receiptMailId=${selectedFullMailBoxNames}`;
        }

        if (showConformation) {
            this._popUpService.showConfirmationPopup(
                'Are you sure?',
                `You want to ${type?.name} this mail?`,
                'Yes',
                (isConfirmed: boolean) => {
                    if (isConfirmed) {
                        this.confirmUpdate(payload, type);
                    }
                },
                false,
                'No'
            );
        } else {
            this.confirmUpdate(payload, type);
        }

        //this.confirmUpdate(payload);
    }

    confirmUpdate(payload: string, type?: any) {
        this.loaderService.showLoader();
        this._universitycommunicationService
            .bulkUpdate(payload)
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(
                (res) => {
                    this.trigger_reload_data.emit({
                        status: true,
                        type
                    });
                    this._toasterService.showSuccess('SUCCESS', '');
                    this.loaderService.hideLoader(); // Added loader hide on success
                },
                (err) => {
                    this.loaderService.hideLoader();
                }
            );
    }

    getFolders() {
        // this.user_details = this._authService.getLoginUserDetails();
        this._mailBoxService.mailFoldersData.pipe(take(1)).subscribe({
            next: (res) => {
                if (res) {
                    this.mailAllotmentFolders = res;
                }
            },
        });
    }

    activityButtonVisibility() {
        this.show_move_to = false;
        this.show_read = false;
        this.show_unread = false;
        this.show_archive = false;
        this.show_important = false;
        this.show_junk = false;
        this.show_shared = false;
        this.showNotImportant = false;
        this.show_inbox = false;
        this.show_delete = false;

        let menu_type = Number(this.menu_type.id);
        let mail_type = this.menu_type?.type;
        switch (menu_type) {
            case this.mail_type_ids.inbox:
                this.show_move_to = true;
                // this.show_read = true;
                // this.show_unread = true;
                this.show_archive = true;
                this.show_important = true;
                this.show_junk = true;
                this.show_shared = true;
                break;

            case this.mail_type_ids.sent:
                this.show_move_to = true;
                // this.show_read = true;
                // this.show_unread = true;
                this.show_archive = false;
                this.show_important = false;
                this.show_junk = false;
                this.show_shared = false;
                break;

            case this.mail_type_ids.important:
                this.show_move_to = true;
                // this.show_read = true;
                // this.show_unread = true;
                this.show_archive = true;
                this.show_important = false;
                this.showNotImportant = true;
                this.show_junk = true;
                this.show_shared = true;
                break;

            case this.mail_type_ids.archived:
                this.show_move_to = true;
                this.show_archive = false;
                this.show_important = false;
                this.show_junk = true;
                this.show_shared = true;
                this.show_inbox = true;
                break;

            case this.mail_type_ids.junk:
                this.show_move_to = true;
                // this.show_read = true;
                // this.show_unread = true;
                this.show_archive = false;
                this.show_important = false;
                this.show_junk = false;
                this.show_shared = true;
                this.show_inbox = true;
                break;

            case this.mail_type_ids.share:
                this.show_archive = false;
                this.show_important = false;
                break;

            case this.mail_type_ids.draft:
                this.show_delete = true
                break;
            case this.mail_type_ids.MMRarchived:
                this.show_move_to = true;
                this.show_junk = true;
                this.show_shared = true;
                this.show_inbox = true;
                break;
        }

        if (mail_type) {
            switch (mail_type) {
                case 'folder':
                    this.show_move_to = true;
                    this.show_read = true;
                    this.show_unread = true;
                    this.show_archive = false;
                    this.show_important = false;
                    this.show_junk = false;
                    this.show_shared = true;
                    break;
                default:
                    this.show_move_to = false;
                    this.show_read = false;
                    this.show_unread = false;
                    this.show_archive = false;
                    this.show_important = false;
                    this.show_junk = false;
                    this.show_shared = false;
                    this.showNotImportant = false;
            }
        }
    }

    openAssignPopup(filter: any = null) {
        const dialogRef = this._dialog.open(AssignMailComponent, {
            width: '100%',
            enterAnimationDuration: '300ms',
            exitAnimationDuration: '100ms',
            disableClose: true,
            data: {
                selected_mails: this.selected_mails,
                filter,
                isReassign: this.isReassign,
                showAssignDone: true
            },
        });
        dialogRef.afterClosed().subscribe((result) => {
            this.triggerReAssignClose.emit(false);
            if (result?.isDone) {
                this.activityConfirmation(this.isMMRTeam ? this.mail_type_ids.MMRarchived : this.mail_type_ids.archived, '', false)
            }
            if (result?.close) {
                this.trigger_reload_data.emit({
                    status: true,
                });
            }
        });
    }

    moveToFolders(type: string, folder_id: string) {
        this.MoveToFolders(type, this.selected_mails, '', folder_id);
    }

    MoveToFolders(
        type: any,
        mail_id: string,
        user_id?: any,
        folder_id?: string
    ) {
        let payload = '';

        if (type === 'imp' || type === 'unimp') {
            payload = `Id=${mail_id}&type=${type === 'imp'
                ? this.mail_type_ids.important
                : this.mail_type_ids.inbox
                }&userId=${this.user_details.id}`;
        } else if (type === 'share') {
            payload = `Id=${mail_id}&type=${this.mail_type_ids.share}&userId=${this.user_details.id}&sharedUserId=${user_id}`;
        } else if (type === 'folder') {
            payload = `Id=${mail_id}&type=${folder_id}&userId=${this.user_details.id}`;
        }

        this.loaderService.showLoader();
        this._universitycommunicationService
            .bulkUpdate(payload)
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(
                (res) => {
                    this._toasterService.showSuccess('SUCCESS', '');
                    this.loaderService.hideLoader();
                    this.trigger_reload_data.emit(true);
                },
                (err) => {
                    this.loaderService.hideLoader();
                }
            );
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }
}
